import api from './api';

export const brandService = {
  getBrands: async (limit = 100) => {
    return api.get(`/brands?limit=${limit}`);
  },
  formatImageUrl: (url) => api.formatImageUrl(url)
};

export default brandService;
